import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStepsMetaFetch } from '../../utils/middlewares';
import { fakeStepMetaSelector, fakeStepsListSelector } from '../../selectors/step';
import ViewSteps from '../view-steps';
class FakeStepsContainer extends Component {
  render() {
    return /*#__PURE__*/React.createElement(ViewSteps, {
      steps: this.props.actualStepsMeta,
      currentStep: this.props.currentStepMeta
    });
  }
}
const mapStateToProps = state => ({
  actualStepsMeta: fakeStepsListSelector(state),
  currentStepMeta: fakeStepMetaSelector(state)
});
const shapeOfStepMeta = {
  isMilestone: PropTypes.bool.isRequired,
  groupIndex: PropTypes.number.isRequired,
  indexInGroup: PropTypes.number
};
FakeStepsContainer.propTypes = {
  actualStepsMeta: PropTypes.arrayOf(PropTypes.shape(shapeOfStepMeta)).isRequired,
  currentStepMeta: PropTypes.shape(shapeOfStepMeta)
};
export default withStepsMetaFetch(connect(mapStateToProps, null)(FakeStepsContainer));